/** CoStar.Api.ConsumerUserData.BrokerRisk.EntityType */
export var EntityType;
(function (EntityType) {
    EntityType[EntityType["None"] = 0] = "None";
    EntityType[EntityType["Email"] = 1] = "Email";
    EntityType[EntityType["Domain"] = 2] = "Domain";
})(EntityType || (EntityType = {}));
/** CoStar.Api.ConsumerUserData.BrokerRisk.RiskLevel */
export var RiskLevel;
(function (RiskLevel) {
    RiskLevel[RiskLevel["None"] = 0] = "None";
    RiskLevel[RiskLevel["Low"] = 1] = "Low";
    RiskLevel[RiskLevel["Medium"] = 2] = "Medium";
    RiskLevel[RiskLevel["High"] = 3] = "High";
})(RiskLevel || (RiskLevel = {}));
